/** Тексты баннера согласия на cookie (7 языков сайта). */
export const translations = {
    en: {
        text: 'We use cookies. Necessary cookies keep the site working (sign-in, language, settings). With your consent we also use analytics cookies (Yandex.Metrica, including session recording) to improve the site. You can change your choice at any time via “Cookie settings” at the bottom of the page.',
        acceptAll: 'Accept all',
        necessaryOnly: 'Necessary only',
        more: 'Terms & Conditions',
        settings: 'Cookie settings',
    },
    es: {
        text: 'Usamos cookies. Las cookies necesarias hacen que el sitio funcione (inicio de sesión, idioma, ajustes). Con tu consentimiento también usamos cookies de analítica (Yandex.Metrica, incluida la grabación de sesiones) para mejorar el sitio. Puedes cambiar tu elección en cualquier momento en «Ajustes de cookies» al pie de la página.',
        acceptAll: 'Aceptar todas',
        necessaryOnly: 'Solo necesarias',
        more: 'Términos y condiciones',
        settings: 'Ajustes de cookies',
    },
    ru: {
        text: 'Мы используем cookie. Необходимые cookie обеспечивают работу сайта (вход, язык, настройки). С вашего согласия мы также используем аналитические cookie (Яндекс.Метрика, включая запись сессий), чтобы улучшать сайт. Изменить выбор можно в любой момент через «Настройки cookie» внизу страницы.',
        acceptAll: 'Принять все',
        necessaryOnly: 'Только необходимые',
        more: 'Условия использования',
        settings: 'Настройки cookie',
    },
    hy: {
        text: 'Մենք օգտագործում ենք cookie-ներ։ Անհրաժեշտ cookie-ներն ապահովում են կայքի աշխատանքը (մուտք, լեզու, կարգավորումներ)։ Ձեր համաձայնությամբ մենք օգտագործում ենք նաև վերլուծական cookie-ներ (Yandex.Metrica, ներառյալ սեանսների ձայնագրումը)՝ կայքը բարելավելու համար։ Ձեր ընտրությունը կարող եք ցանկացած պահի փոխել էջի ներքևում գտնվող «Cookie-ների կարգավորումներ» բաժնում։',
        acceptAll: 'Ընդունել բոլորը',
        necessaryOnly: 'Միայն անհրաժեշտները',
        more: 'Օգտագործման պայմաններ',
        settings: 'Cookie-ների կարգավորումներ',
    },
    fr: {
        text: 'Nous utilisons des cookies. Les cookies nécessaires assurent le fonctionnement du site (connexion, langue, paramètres). Avec votre consentement, nous utilisons aussi des cookies d’analyse (Yandex.Metrica, y compris l’enregistrement des sessions) pour améliorer le site. Vous pouvez modifier votre choix à tout moment via « Paramètres des cookies » en bas de page.',
        acceptAll: 'Tout accepter',
        necessaryOnly: 'Nécessaires uniquement',
        more: 'Conditions d’utilisation',
        settings: 'Paramètres des cookies',
    },
    de: {
        text: 'Wir verwenden Cookies. Notwendige Cookies sorgen dafür, dass die Website funktioniert (Anmeldung, Sprache, Einstellungen). Mit Ihrer Einwilligung verwenden wir außerdem Analyse-Cookies (Yandex.Metrica, einschließlich Sitzungsaufzeichnung), um die Website zu verbessern. Sie können Ihre Auswahl jederzeit über „Cookie-Einstellungen“ unten auf der Seite ändern.',
        acceptAll: 'Alle akzeptieren',
        necessaryOnly: 'Nur notwendige',
        more: 'Nutzungsbedingungen',
        settings: 'Cookie-Einstellungen',
    },
    it: {
        text: 'Utilizziamo i cookie. I cookie necessari garantiscono il funzionamento del sito (accesso, lingua, impostazioni). Con il tuo consenso utilizziamo anche cookie analitici (Yandex.Metrica, inclusa la registrazione delle sessioni) per migliorare il sito. Puoi modificare la tua scelta in qualsiasi momento tramite «Impostazioni cookie» in fondo alla pagina.',
        acceptAll: 'Accetta tutti',
        necessaryOnly: 'Solo necessari',
        more: 'Termini e condizioni',
        settings: 'Impostazioni cookie',
    },
}
